import { VueCookieNext } from 'vue-cookie-next'
import { apiGetSessionToken } from '@/services/APointAPI'
import { encrypt, decrypt } from '@/services/APointAPI'

export const apiStore = {
  namespaced: true,
  state: {
    encryptionKey: '9E965C55-22A3-4E2A-9DE0-1F41A4F0526A',
    User: {},
    userName: '',
    pswd: '',
    userID: 0,
    compGUID: '',
    compID: '',
    sessionToken: '',
    tokenCreated: null,
    webPswd: '',
    loggedIn: false,
    contactID: 0,
    bID: 0,
    uID: 0,
    dealerNumber: null,
    companiesCount: 0,
    createHok: null,
    languageId: null,
    PermSrvCall: 0,
    PermClearing: 0,
    WorkerName: '',
    showRulesServiceCall: false,
    serviceCallsSearch: null,
    serviceCallsOrder: null,
    buildingsSearch: null,
    buildingsOrder: null,
    openServiceCallsCnt: null,
    allowReceptionistModule: null,
    hideNavigation: false,
    isBuildingValidToChex: null,
  },
  mutations: {
    setSessionData(state, payload) {
      for (let key of Object.keys(payload)) {
        // console.log(`key: ${key}: ${payload[key]}`);
        if (payload[key] !== undefined) {
          state[key] = payload[key]
          let cookieData = encrypt(payload[key])
          // console.log(decrypt(VueCookieNext.getCookie(key)));
          if (key !== 'sessionToken') VueCookieNext.setCookie(key, cookieData)
        } else {
          state[key] = ''
          let cookieData = encrypt('')
          if (key !== 'sessionToken') VueCookieNext.setCookie(key, cookieData)
        }
      }
    },
    setSessionDataFromCookie(state) {
      for (let key of VueCookieNext.keys()) {
        let cookieData = decrypt(VueCookieNext.getCookie(key))
        // console.log(key, cookieData, VueCookieNext.getCookie(key));
        if (key != 'bannerId') {
          state[key] = cookieData
        }
        // console.log(key, decrypt(VueCookieNext.getCookie(key)));
      }
    },
    setCompGuid(state, payload) {
      state.compGUID = payload
    },
    resetToken(state) {
      // console.log('api/resetToken')
      state.sessionToken = ''
      state.tokenCreated = null
    },
    setToken(state, payload) {
      state.sessionToken = payload
      state.tokenCreated = new Date()
    },
  },
  actions: {
    getCompGuidFromSecureCookie({ commit }, payload) {
      commit('setCompGuid', payload)
    },
    checkLogIn({ commit, getters }) {
      let loggedIn = decrypt(VueCookieNext.getCookie('loggedIn'))
      let compID = decrypt(VueCookieNext.getCookie('compID'))
      let User = decrypt(VueCookieNext.getCookie('User'))
      let userName = User?.userName
      let userPswd = User?.pswd
      // let webPswd = decrypt(VueCookieNext.getCookie("webPswd"));
      if (
        loggedIn === true &&
        compID &&
        userName &&
        userPswd &&
        getters.isLoggedIn == false
      ) {
        commit('setSessionDataFromCookie')
        return apiGetSessionToken(compID, userName, userPswd)
      }
    },
  },
  modules: {},
  getters: {
    // GetSMSFromPhoneNum: (state) => {
    //   return state.SMSFromPhoneNum;
    // },
    GetWorkerName: (state) => {
      return state.WorkerName
    },
    GetPermClearing: (state) => {
      return state.PermClearing
    },
    GetPermSrvCall: (state) => {
      return state.PermSrvCall
    },
    // GetPermTenantRoom: (state) => {
    //   return state.PermTenantRoom;
    // },
    // GetPermVaadMembers: (state) => {
    //   return state.PermVaadMembers;
    // },
    isLoggedIn: (state) => {
      return state.sessionToken !== '' && state.compID !== '' && state.loggedIn
    },
    compGUID: (state) => {
      return state.compGUID
    },
    contactID: (state) => {
      return state.contactID
    },
    bID: (state) => {
      return state.bID
    },
  },
}
